module.exports = __webpack_public_path__ + "static/img/icon_lock.1dccbd2c.svg";